import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import Loading from '../../ui/loading';
import { fetchSectionAttribute } from '../../../services/section-attributes';
import { SectionAttributeContext } from '../../../providers/SectionAttributeProvider';

const ServicesForm = ({ 
  section,
  isSubmitting
}) => {

  const [isLoading, setIsloading] = useState(true);
  const { sectionAttribute, setSectionAttribute } = useContext(SectionAttributeContext);

  const getSectionAttribute = useCallback(async () => {
    if (section) {
      try {
        const response = await fetchSectionAttribute(section);
        setSectionAttribute(response.data);
        setIsloading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  }, [section, setSectionAttribute]);
  
  const shouldFetch = useMemo(() => Object.keys(sectionAttribute).length === 0, [sectionAttribute]);

  useEffect(() => {
    if (shouldFetch) {
      getSectionAttribute();
    }
  }, [shouldFetch, getSectionAttribute]);

  const handleUpdate = e => {
    const { name, value } = e.target;

    setSectionAttribute(prevState => {
      // Split level name if is nested, i.e: "data.services[0].name"
      const keys = name.split('.');

      // Recusrive functon to create a new state nested
      const updateNestedState = (obj, keys, value) => {
        const [firstKey, ...restKeys] = keys;
        if (restKeys.length === 0) {
          // Last key, update the value
          return {
            ...obj,
            [firstKey]: value
          };
        }

        // Handle arrays inside de data
        if (firstKey.endsWith(']')) {
          // Get array index, i.e.: "services[0]"
          const arrayKey = firstKey.slice(0, firstKey.indexOf('['));
          const index = parseInt(firstKey.slice(firstKey.indexOf('[') + 1, firstKey.indexOf(']')), 10);

          return {
            ...obj,
            [arrayKey]: obj[arrayKey].map((item, idx) => 
              idx === index 
                ? updateNestedState(item, restKeys, value)
                : item
            )
          };
        }

        // No final key, keep nesting
        return {
          ...obj,
          [firstKey]: updateNestedState(obj[firstKey], restKeys, value)
        };
      };

      // If key is nested, start from prevState.data
      if (keys[0] === 'data') {
        return {
          ...prevState,
          data: updateNestedState(prevState.data, keys.slice(1), value)
        };
      }

      // If key is not nested, update to superior level
      return {
        ...prevState,
        [name]: value
      };
    });
  };

  if (isLoading) return (
    <div className="w-full">
      <Loading />
    </div>
  );

  return (
    <form className="grid w-full items-start gap-6">
      <fieldset className="grid gap-6 rounded-lg border p-4">
        <legend className="-ml-1 px-1 text-sm font-medium">
          Servicios
        </legend>
        <div className="grid gap-3">
          <Label htmlFor="Título">Servicio I - Título</Label>
          <Input 
            id="data.services.0.title"
            type="text"
            name="data.services[0].title"
            placeholder="Escribe el titulo de servicio"
            value={sectionAttribute?.data?.services?.[0]?.title}
            onChange={handleUpdate}
            disabled={isSubmitting} />
        </div>
        <div className="grid grid-cols-1 gap-4">
          <div className="grid gap-3">
            <Label htmlFor="top-p">Servicio I - Descripción</Label>
            <Textarea
              id="data.services.0.description"
              type="text"
              name="data.services[0].description"
              placeholder="Escribe una descripción"
              className="min-h-[4.5rem]"
              value={sectionAttribute?.data?.services?.[0]?.description}
              onChange={handleUpdate}
              disabled={isSubmitting}
            />
          </div>
        </div>
        <hr />
        <div className="grid gap-3">
          <Label htmlFor="Título">Servicio II - Título</Label>
          <Input
            id="data.services.1.title"
            type="text"
            name="data.services[1].title"
            placeholder="Escribe el titulo de servicio"
            value={sectionAttribute?.data?.services?.[1]?.title}
            onChange={handleUpdate}
            disabled={isSubmitting} />
        </div>
        <div className="grid grid-cols-1 gap-4">
          <div className="grid gap-3">
            <Label htmlFor="top-p">Servicio II - Descripción</Label>
            <Textarea
              id="data.services.1.description"
              type="text"
              name="data.services[1].description"
              placeholder="Escribe una descripción"
              className="min-h-[4.5rem]"
              value={sectionAttribute?.data?.services?.[1]?.description}
              onChange={handleUpdate}
              disabled={isSubmitting}
            />
          </div>
        </div>
        <hr />
        <div className="grid gap-3">
          <Label htmlFor="Título">Servicio III - Título</Label>
          <Input 
            id="data.services.2.title"
            type="text"
            name="data.services[2].title"
            placeholder="Escribe el titulo de servicio"
            value={sectionAttribute?.data?.services?.[2]?.title}
            onChange={handleUpdate}
            disabled={isSubmitting} />
        </div>
        <div className="grid grid-cols-1 gap-4">
          <div className="grid gap-3">
            <Label htmlFor="top-p">Servicio III - Descripción</Label>
            <Textarea
              id="data.services.2.description"
              type="text"
              name="data.services[2].description"
              placeholder="Escribe una descripción"
              className="min-h-[4.5rem]"
              value={sectionAttribute?.data?.services?.[2]?.description}
              onChange={handleUpdate}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </fieldset>
    </form>
  );
};

export default ServicesForm;